module.exports = __webpack_public_path__ + "files/fff1493483f16878e7016ed9b1661040.png";